export const VALIDATION_REQUIRED = 'Esse campo é obrigatório'
export const VALIDATION_EMAIL = 'Email inválido'
export const VALIDATION_INVALID = 'Esse campo está com valor inválido'
export const VALIDATION_CPF = 'CPF inválido'
export const VALIDATION_MINLENGTH = 'O número mínimo de caracteres para esse campo é: '
export const VALIDATION_MAXLENGTH = 'O número máximo de caracteres para esse campo é: '



// WEBPACK FOOTER //
// ./src/app/messages.js